module.exports = __webpack_public_path__ + "img/member-none-photo.9ce0ef21.svg";